import { render, staticRenderFns } from "./ProductSamplingView.vue?vue&type=template&id=bb07cd4a&scoped=true"
import script from "./ProductSamplingView.vue?vue&type=script&lang=js"
export * from "./ProductSamplingView.vue?vue&type=script&lang=js"
import style0 from "./ProductSamplingView.vue?vue&type=style&index=0&id=bb07cd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb07cd4a",
  null
  
)

export default component.exports